import React, {useRef, useState} from 'react';
import {MaintenanceNotificationWithRecordResponse} from '@di-shared/api/di/__generated';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import SestExchangeHistorySelection from '@di-shared/features/diag/exchange/history/bottom-sheet/SestExchangeHistorySelection';

function SestExchangeHistoryManualBottomSheetPage() {
  const vin = window.data.vin as unknown as string;
  const comparisonNotification = window.data.comparisonNotification as unknown as MaintenanceNotificationWithRecordResponse[];

  const [stepIndex, setStepIndex] = useState(0);
  const steps = useRef<JSX.Element[]>([]);

  async function nextStep() {
    setStepIndex((stepIndex) => {
      if (stepIndex >= steps.current.length - 1) {
        window.bottomSheetClose();
        return stepIndex + 1;
      }
      return stepIndex + 1;
    });
  }

  if (steps.current.length === 0) {
    comparisonNotification.forEach(({newRecord, existRecord, id}) => {
      steps.current.push(
        <SestExchangeHistorySelection
          key={id}
          notificationId={id}
          onNext={nextStep}
          vin={vin}
          records={[newRecord, existRecord]}
        />
      );
    });
  }
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={300}>
      <div>{steps.current[stepIndex]}</div>
    </BottomSheetWebViewWrapper>
  );
}

export default SestExchangeHistoryManualBottomSheetPage;
